import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-clouds"; // Import the Dracula theme
import "ace-builds/src-noconflict/mode-text"; // Use plain text mode

import { runPythonCode } from "./Pyodide";
import Button from "@mui/material/Button";
import { BasicTabs } from "./FileTabs";
import Snackbar from "@mui/material/Snackbar";
import { IDEContext } from "../Chat/Chat";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useSaveInteraction } from "../../utils/useSaveInteraction";

interface ChatMessages {
  isAi: boolean;
  content: string;
  typing?: boolean;
  uniqueId?: string;
  imgURLs?: string[];
  comment?: string;
  error: boolean;
}

interface IDEProps {
  pdfInfo: string,
  // title: string;
  Messages: ChatMessages[];
  handleSendMessage: (promptMessage: string) => Promise<void>;
  exportCode: (prompt: string) => void;
}

interface Interaction {
  name: string;
  context: {}
}

export const IDE: React.FC<IDEProps> = ({
  pdfInfo,
  Messages,
  exportCode,
}) => {
  const { saveInteraction } = useSaveInteraction();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fileName, _setFileName] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fileContent, _setFileContent] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fileBuffer, _setFileBuffer] = useState<ArrayBuffer>(
    new ArrayBuffer(0)
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_newfileBuffer, setNewFileBuffer] = useState<ArrayBuffer>(
    new ArrayBuffer(0)
  );

  const {
    IDECode,
    setIDECode,
    IDEOutputCode,
    setIDEOutputCode,
    IDEfileNameState: newFileNames,
    setIDEFileNameState: setNewFileNames,
    IDEFileBufferState: newFileBuffers,
    setIDEFileBufferState: setNewFileBuffers,
    IDEModifiedFileBufferState: modifiedFileBuffers,
    setModifiedFileBufferState: setModifiedFileBuffers,
  } = React.useContext(IDEContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [tabValue, setTabValue] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [editText, setEditText] = useState<string>("");

  const [SnackbarOpen, setSnackbarOpen] = React.useState(false);

  // theme
  const theme = useTheme();

  const editorTheme = theme.palette.mode === "dark" ? "monokai" : "clouds";

  const [editorMode, setEditorMode] = useState<string>("python");
  const [editorSaveCodeFlag, setEditorSaveCodeFlag] = useState<boolean>(true);

  useEffect(() => {
    setEditText(IDECode);
  }, [IDECode]);

  const handleEditorChange = (value: string) => {
    setEditText(value);
    if (editorSaveCodeFlag) {
      setIDECode(value);
    } else {
      const txtBuffer = textToArrayBuffer(value);
      console.log("The txtBuffer", txtBuffer);
      var uint8Array = new Uint8Array(txtBuffer);

      var fileId = newFileNames.indexOf(tabValue);

      setModifiedFileBuffers((prevBuffers) => {
        // Create a copy of the previous buffers array
        const updatedBuffers = [...prevBuffers];
        // Update the buffer at the specified index
        updatedBuffers[fileId] = uint8Array;
        // Return the updated array to set as the new state
        return updatedBuffers;
      });
    }
  };

  const runCode = async (code: string) => {
    const pattern =
      /input\(\s*(?:(['"`])\1\1([^]*?)\1\1\1|(['"`])([^]*?)\3)\s*\)/g;
    const updatedCode = code.replace(pattern, (match, a, b, c, d) => {
      const capturedText = b || d;
      const newText = prompt(capturedText);
      return newText !== null ? `"${newText}"` : match;
    });

    code = updatedCode;

    const language = "python";
    let result;
    if (language === "python") {
      result = await runPythonCode(
        code,
        fileName,
        fileContent,
        fileBuffer,
        newFileNames,
        modifiedFileBuffers
      );
    }

    console.log("result", result);
    let output = ""

    if (result?.stdoutLines) {
      output = result.stdoutLines.join("\n");
      setIDEOutputCode(output);
      // console.log("IDE got",result.stdoutLines)
    }

    if (result?.modifiedFileBuffer) {
      console.log(
        "This is the modified filebuffer from IDE get",
        result?.modifiedFileBuffer
      );
      setNewFileBuffer(result?.modifiedFileBuffer);
    }

    if (result?.modifiedFileNames) {
      setNewFileNames(result?.modifiedFileNames);
      console.log(
        "These are the new files form the FS",
        result?.modifiedFileNames
      );
      console.log(
        "This is the modified filebuffers from IDE get",
        result?.modifiedFileBuffers
      );
      setModifiedFileBuffers(result?.modifiedFileBuffers);
    }

    if (result?.error) {
      output = result.error;
      setIDEOutputCode(output);

      // This would cover the result if there is an error
    } else {
      console.log("Error getting the result");
    }

    saveInteraction({
      name: "frontend-interaction-ide-runcode",
      context: {
        userCode: code,
        outputCode: output
      }
    })

  };

  const handleManyFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    // save upload file action
    saveInteraction({
      name: "frontend-interaction-ide-uploadfile",
      context: {
        pdfID: pdfInfo
      }
    })

    if (files) {
      const newFileNameslst = [];
      // const newFileBuffersArray = [];
      const newFileBuffersArray: Array<ArrayBuffer> = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        newFileNameslst.push(file.name);
        setNewFileNames((prevNames) => [...prevNames, file.name]);
        console.log("The state newFileNames", newFileNames);

        file.arrayBuffer().then((arrayBuffer) => {
          // Ensure that arrayBuffer is a genuine ArrayBuffer
          if (arrayBuffer instanceof ArrayBuffer) {
            // Create a Uint8Array view on the ArrayBuffer
            var uint8Array = new Uint8Array(arrayBuffer);

            // Now you can manipulate the binary data using the Uint8Array
            console.log("Uint8Array:", uint8Array);

            // For example, you can access individual bytes using the Uint8Array
            // console.log("First byte:", uint8Array[0]);

            // Check if arrayBuffer is recognized as a view
            console.log(
              "Is arrayBuffer recognized as a view?",
              ArrayBuffer.isView(uint8Array)
            );
            // console.log("Is this original one as a view?", ArrayBuffer.isView(arrayBuffer));

            // You can also modify the data if needed
            // uint8Array[0] = 255; // Modify the first byte

            newFileBuffersArray.push(uint8Array);

            // setNewFileBuffers([...newFileBuffers,...[uint8Array]]);
            setNewFileBuffers((prevBuffers) => [...prevBuffers, uint8Array]);
            setModifiedFileBuffers((prevBuffers) => [
              ...prevBuffers,
              uint8Array,
            ]);

            console.log("The state:", newFileBuffers);

          } else {
            console.error(
              "file.arrayBuffer() did not return a valid ArrayBuffer."
            );
          }
        });
      }
    }
  };

  const saveCodeToFile = (code: string) => {
    const buffer = textToArrayBuffer(code);
    // use buffer with handlemanyfilechange

    // setNewFileBuffers([...newFileBuffers, buffer]);
    setNewFileBuffers((prevBuffers) => [...prevBuffers, buffer]);
    setModifiedFileBuffers((prevBuffers) => [...prevBuffers, buffer]);
    // setNewFileNames([...newFileNames, "newfile.txt"]);
    // file name is code - time stamp
    const time = new Date().getTime();
    setNewFileNames((prevNames) => [...prevNames, `code-${time}.txt`]);
  };

  // const openfile = (name: string) => {
  //   console.log("file name:", name);
  // };
  const value_change = (value: string) => {
    // save upload file action
    saveInteraction({
      name: "frontend-interaction-ide-switchtab",
      context: {
        fileName: value
      }
    })
    setTabValue(value);
    console.log("The newly chosen value got at IDE", value);

    if (value === "Code Space") {
      setEditorMode("python");
      // editor.setValue(IDECode);
      setEditorSaveCodeFlag(true);
      setEditText(IDECode);
    } else {
      setEditorSaveCodeFlag(false);
      console.log("Current tab", value);
      if (value.endsWith(".txt")) {
        // Files

        // editor = ace.edit("editor");
        // editor.setTheme(editorTheme);
        // editor.session.setMode("ace/mode/text");
        setEditorMode("text");
        // editor.setValue(editText);

        var fileid = newFileNames.indexOf(value);
        console.log("The file id:", fileid);
        console.log("double checking the name:", newFileNames[fileid]);
        console.log("The file buffer:", modifiedFileBuffers[fileid]);

        // Here we use modified file buffers, make it consistent with the new file buffers
        // And we can capture the changes made by code

        const filect = arrayBufferToText(modifiedFileBuffers[fileid]);
        console.log(filect);
        setEditText(filect);

      } else if (
        value.endsWith(".png") ||
        value.endsWith(".jpg") ||
        value.endsWith(".jpeg") ||
        value.endsWith(".gif")
      ) {
        // Images
        setEditorMode("image");
        fileid = newFileNames.indexOf(value);
        console.log("The file id:", fileid);
        console.log("double checking the name:", newFileNames[fileid]);
        addImageToDiv("editorImage", modifiedFileBuffers[fileid]);
      } else {
        //if(value.endsWith(".pdf")){
        setEditorMode("text");
        setEditText("This file type is not supported.");
      }

      // A problem of how to
    }
  };

  function arrayBufferToText(arrayBuffer: ArrayBuffer) {
    return new TextDecoder().decode(arrayBuffer);
  }

  function textToArrayBuffer(text: string) {
    const encoder = new TextEncoder();
    return encoder.encode(text).buffer;
  }

  const handleSnackbarClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  const SnackbarActivate = () => {
    setSnackbarOpen(true);
  };

  // About the interactions
  const addCodeInterpreterActions = (interaction: Interaction) => {
    saveInteraction({
      name: interaction.name,
      context: interaction.context
    })
  };

  function addImageToDiv(divId: string, buffer: ArrayBuffer) {
    // Create a new image element
    const image = new Image();

    // Create a blob from the buffer
    const blob = new Blob([buffer], { type: "image/jpeg" }); // Adjust the MIME type according to your image format

    // Set the source of the image using the blob URL
    image.src = URL.createObjectURL(blob);

    // Append the image to the specified div
    const div = document.getElementById(divId);
    if (div) {
      div.appendChild(image);
    }
  }

  return (
    <Stack height="100%">
      <Box id="tab" height="10%">
        <BasicTabs
          fileNames={newFileNames}
          value_change={value_change}
          addCodeInterpreterActions={addCodeInterpreterActions}
          modifiedFileBuffers={modifiedFileBuffers}
          handleManyFileChange={handleManyFileChange}
        />
      </Box>

      {/* <Typography
        component="div"
        id="editor"
        height="65%"
        width="100%"
        fontFamily="monospace"
      ></Typography> */}
      {editorMode !== "image" ? (
        <AceEditor
          mode={editorMode}
          theme={editorTheme}
          name="editor"
          value={editText}
          onChange={handleEditorChange}
          style={{ width: "100%", height: "70%", fontFamily: "monospace", marginTop: "15px" }}
        />
      ) : (
        <Box style={{ width: "100%", height: "70%" }} id="editorImage"></Box>
      )}

      <Snackbar
        open={SnackbarOpen}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message="Code executed and files updated."
      />

      <Box height="20%">
        <Stack
          direction="row"
          spacing={1}
          sx={{
            height: "20%",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              runCode(IDECode);
              SnackbarActivate();
            }}
          >
            Run Code
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const code_correction_prompt = `I have the following solution for question #.\n\n\`\`\`python[change to your language]\n${IDECode}\n\`\`\`\nOutput:\n\`\n${IDEOutputCode}\n\``;
              saveInteraction({
                name: "frontend-interaction-ide-movecodetochat",
                context: {
                  userCode: IDECode,
                  outputCode: IDEOutputCode
                }
              })
              exportCode(code_correction_prompt);
            }}
          >
            Move Code and Output to Chat
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              saveInteraction({
                name: "frontend-interaction-ide-savecodetofile",
                context: {
                  userCode: IDECode,
                  outputCode: IDEOutputCode
                }
              })
              saveCodeToFile(IDECode);
            }}
          >
            Move Code to File
          </Button>
        </Stack>
        <Paper
          sx={{
            height: "80%",
            overflow: "auto",
          }}
        >
          <Typography
            component="pre"
            id="code-output"
            fontFamily="monospace"
            width="100%"
          >
            {IDEOutputCode || "Output will appear here."}
          </Typography>
        </Paper>
      </Box>
    </Stack>
  );
};

// export default IDE;
